import { render, staticRenderFns } from "./ContentNavigation.vue?vue&type=template&id=66e0472b&scoped=true&"
import script from "./ContentNavigation.vue?vue&type=script&lang=js&"
export * from "./ContentNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0472b",
  null
  
)

export default component.exports